import { TopNav } from './TopNav';
import { BottomNav } from './BottomNav';
import { WhatsAppButton } from '@/components/WhatsAppButton';

export function CustomerLayout({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <TopNav />
      <main className="pb-20 md:pb-8">
        {children}
      </main>
      <BottomNav />
      <WhatsAppButton />
    </div>
  );
}
